<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card>
                  <v-card-title>
                    <v-layout row wrap align-end>
                    <v-flex>
                      <h1> Busca de Empresas </h1>
                      <v-spacer></v-spacer>
                    </v-flex>
                    <v-flex>
                       <v-text-field
                        append-icon="search"
                        single-line
                        hide-details
                        v-model="search"
                    ></v-text-field>
                    </v-flex>
                    </v-layout>

                  </v-card-title>
                  <v-card-text>
                      <v-container>
                      <v-layout row>
                          <v-flex xs-8>
                        <v-data-table
                        :headers="headers"
                        :items="rows"
                        :loading="animation"
                        :search="search"
                        >
                        <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
                        <template slot="items" slot-scope="props">
                          <td @click="gotoProject(props.item)">{{ props.item.name }}</td>
                          <td @click="gotoProject(props.item)">{{ props.item.cidade}}</td>
                          <td @click="gotoProject(props.item)">{{ props.item.logradouro }}</td>                            
                        </template>
                        <v-alert slot="no-results" :value="true" color="error" icon="warning">
                            Sua busca por "{{ search }}" não encontrou resultados.
                        </v-alert>
                        <template v-if="mensagem" slot="no-data">
                            Ops... Nenhum dado no momento
                        </template>
                        <template v-if="!mensagem" slot="no-data">
                            Carregando os dados
                        </template>
                        </v-data-table>
                          </v-flex>

                      </v-layout>
                      </v-container>
                  </v-card-text>
              </v-card>
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'

export default {
  data () {
    return {
      search: '',
      animation: true,
      mensagem: false,
      headers: [
        { text: 'Nome', value: 'name' },
        { text: 'Cidade', value: 'cidade' },
        { text: 'Local', value: 'logradouro' }
      ],
      rows: []
    }
  },
  methods: {
    gotoProject (row) {
      this.$router.push(
        {name: 'empresa-detail',
          params: {'id': row.id}
        })
    }
  },
  mounted () {
    api.request('GET', 'companies/').then(response => {
      var arr = response.data.map(function (data, index) {
        return {
          name: data.name,
          slug: data.slug,
          cidade: data.cidade,
          id: data.id,
          phonenumber: data.phonenumber,
          logradouro: data.logradouro
        }
      })
      this.rows = arr
      this.animation = false
      this.mensagem = true
    })
  }
}
</script>

<style lang="scss" scoped>

td:hover{
  cursor: pointer; 
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Empresas/Search.vue